// src/components/KPICards.jsx
import React from 'react';
import { ArrowDownCircle, ArrowUpCircle, DollarSign } from 'lucide-react';
import { formatCurrency } from '../lib/constants';

export default function KPICards({ totalInflows, totalOutflows, balance }) {
  const cards = [
    {
      label: 'Total Inflows',
      value: totalInflows,
      color: 'indigo',
      Icon: ArrowDownCircle,
    },
    {
      label: 'Total Outflows',
      value: totalOutflows,
      color: 'rose',
      Icon: ArrowUpCircle,
    },
    {
      label: 'Current Cash Balance',
      value: balance,
      color: 'emerald',
      Icon: DollarSign,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {cards.map(({ label, value, color, Icon }) => (
        <div
          key={label}
          className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-center gap-5 relative overflow-hidden"
        >
          <div className={`absolute left-0 top-0 bottom-0 w-1.5 bg-${color}-500`} />
          <div className={`p-3 bg-${color}-50 rounded-full text-${color}-600 border border-${color}-100`}>
            <Icon className="w-6 h-6" />
          </div>
          <div>
            <p className="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">{label}</p>
            <p className="text-2xl font-bold text-slate-900">{formatCurrency(value)}</p>
          </div>
        </div>
      ))}
    </div>
  );
}